// Tidy a scraped report title for display: drop the "INDEX:… Sector:… Position:…"
// metadata some scrapers appended to the title, and decode common HTML entities.
export const cleanTitle = (t) => {
  if (!t) return '';
  return String(t)
    .replace(/\s*INDEX:.*$/i, '')
    .replace(/&amp;/g, '&')
    .replace(/&#8217;|&#8216;/g, '’')
    .replace(/&#8220;|&#8221;/g, '"')
    .replace(/&#\d+;/g, '')
    .trim();
};
